var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hm-content',{attrs:{"title":"编辑排班"}})}
var staticRenderFns = []

export { render, staticRenderFns }